import { ShowDrafts, ShowEpisodes } from 'resources';
import prependToCollection from 'app/collection/actions/prepend';
import removeFromCollection from 'app/collection/actions/remove';

export default episode => {
  removeFromCollection(ShowEpisodes, episode.show, [episode]);
  prependToCollection(ShowDrafts, episode.show, [episode]);
};
